import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

export enum EReportersIcons {
  VET = "vet",
  RACING_SECRETARY = "racing_secretary",
  TRAINER = "trainer",
  OTHER_USERS = "other_users"
}

export enum ECommentDisplayingVariant {
  COMMENT_FOR_TRAINER = "comment_for_trainer",
  COMMENT_FOR_VETERINARIAN = "comment_for_veterinarian",
  MODAL = "modal"
}

interface IDisplayingVariants {
  isModalVariant: boolean;
  isCommentForTrainerVariant: boolean;
  isCommentForVetVariant: boolean;
}

export const checkDisplayingVariants = (
  variant: ECommentDisplayingVariant
): IDisplayingVariants => {
  return {
    isModalVariant: variant === ECommentDisplayingVariant.MODAL,
    isCommentForTrainerVariant:
      variant === ECommentDisplayingVariant.COMMENT_FOR_TRAINER,
    isCommentForVetVariant:
      variant === ECommentDisplayingVariant.COMMENT_FOR_VETERINARIAN
  };
};

export const getCommentTypeLabel = (type: racehorse360.EventType): string => {
  const {
    EVENT_TYPE_WORKOUT_REQUEST,
    EVENT_TYPE_HORSE_EXAM,
    EVENT_TYPE_HORSE_GENERAL_VET_COMMENT
  } = racehorse360.EventType;

  switch (type) {
    case EVENT_TYPE_HORSE_EXAM:
      return "Vet Exam";
    case EVENT_TYPE_WORKOUT_REQUEST:
      return "Workout";
    case EVENT_TYPE_HORSE_GENERAL_VET_COMMENT:
      return "General Vet Comment";
    default:
      return "";
  }
};

export const getReporterRoleIcon = (
  type:
    | racehorse360.HorseAggregatedCommentIconType
    | racehorse360.NotificationCreatorRole,
  displayVariant: ECommentDisplayingVariant
): EReportersIcons => {
  const {
    HORSE_AGGREGATED_COMMENT_ICON_TYPE_GENERAL,
    HORSE_AGGREGATED_COMMENT_ICON_TYPE_VETERINARIAN,
    HORSE_AGGREGATED_COMMENT_ICON_TYPE_TRAINER
  } = racehorse360.HorseAggregatedCommentIconType;
  const {
    NOTIFICATION_CREATOR_ROLE_OTHER,
    NOTIFICATION_CREATOR_ROLE_VETERINARIAN
  } = racehorse360.NotificationCreatorRole;

  if (displayVariant === ECommentDisplayingVariant.MODAL) {
    switch (type) {
      case NOTIFICATION_CREATOR_ROLE_OTHER:
        return EReportersIcons.OTHER_USERS;
      case NOTIFICATION_CREATOR_ROLE_VETERINARIAN:
        return EReportersIcons.VET;
    }
  } else if (displayVariant === ECommentDisplayingVariant.COMMENT_FOR_TRAINER) {
    switch (type) {
      case HORSE_AGGREGATED_COMMENT_ICON_TYPE_VETERINARIAN:
        return EReportersIcons.VET;
      default:
        return EReportersIcons.OTHER_USERS;
    }
  } else if (
    displayVariant === ECommentDisplayingVariant.COMMENT_FOR_VETERINARIAN
  ) {
    switch (type) {
      case HORSE_AGGREGATED_COMMENT_ICON_TYPE_GENERAL:
        return EReportersIcons.OTHER_USERS;
      case HORSE_AGGREGATED_COMMENT_ICON_TYPE_VETERINARIAN:
        return EReportersIcons.VET;
      case HORSE_AGGREGATED_COMMENT_ICON_TYPE_TRAINER:
        return EReportersIcons.TRAINER;
    }
  }
};
